/* eslint-disable complexity */
import { AppState } from 'src/app/store'
import { getOptionalFieldWithExcelData, isNotTypeOnArray } from 'src/core/helpers'

export const hasErrorsCreateIntegration = (state: AppState): boolean => {
  const error = state?.myIntegration.createIntegration.error
  return error !== null && error?.errors?.length > 0
}
export const reactivateIntegrationSelector = (state: AppState) => state.myIntegration.reactivateIntegration
export const createIntegrationSelector = (state: AppState) => state.myIntegration.createIntegration
export const allProjectsIntegrationSelector = (state: AppState) => state.myIntegration.allProjects
export const CreateDepositSelector = (state: AppState) => state.myIntegration.createDeposit
export const PrePurchaseSelector = (state: AppState) => state.myIntegration.prePurchase
export const developersMainChartDataSelector = (state: AppState) => state.myIntegration.mainChartData
export const userIntegrationListSelector = (state: AppState) => state.myIntegration.userIntegrationsList
export const integrationWhiteLabelSelector = (state: AppState) => state.myIntegration.integrationWhiteLabel

// OFFSET By Excel Selectors

export const offsetByExcelSelector = (state: AppState) => state.myIntegration.offsetByExcel
export const integrationChartDataSelector = (state: AppState) => state.myIntegration.integrationChartData
export const integrationPurchasesSelector = (state: AppState) => state.myIntegration.integrationPurchasesList
export const offsetByExcelMakePurchasesSelector = (state: AppState) => state.myIntegration.offsetByExcel.makePurchases
export const integrationProjectListSelector = (state: AppState) => state.myIntegration.integrationProjectsList
export const integrationProjectToShareSelector = (state: AppState) => state.myIntegration.integrationsToShareProjectList
export const integrationStaticsSelector = (state: AppState) => state.myIntegration.integrationStatics
export const offsetByExcelPrepareSelector = (state: AppState) => state.myIntegration.offsetByExcel.preparePurchases
export const offsetKeysSelector = (state: AppState) => state.myIntegration.offsetByExcel.offsetKeys
export const offsetOptionalFieldsSelector = (state: AppState) => state.myIntegration.offsetByExcel.optionalFields
export const currentOffsetStep = (state: AppState): number => {
  return state.myIntegration.offsetByExcel.step
}

export const isOffsetNextButtonDisabled = (state: AppState): boolean => {
  const { keys, excelData } = state.myIntegration.offsetByExcel
  return keys.length === 0 && excelData.length === 0
}
export const selectFinalUnitPrice = (state: AppState) => state.myIntegration.final_unit_price
export const getOffsetByExcelVerifyErrors = (state: AppState): {
  hasErrors: boolean, errors: {label: string, key: string}[]
} => {
  const {
    offsetKeys, excelData,
    optionalFields: { use_company_name_in_offset }
  } = state.myIntegration.offsetByExcel
  let values = { hasErrors: false, errors: [] }
  for (var key in offsetKeys) {
    if (!offsetKeys[key]) {
      if ((use_company_name_in_offset && !['nameField', 'lastNameField'].includes(key))
        || (!use_company_name_in_offset && !['companyNameField'].includes(key)))
        values.errors.push({ label: `${key}Required`, key })
      values.hasErrors = true
    }
  }
  // Validate fields and its type, string or number
  const { amountCo2Field, nameField, lastNameField, emailField, companyNameField } = offsetKeys
  if (isNotTypeOnArray(excelData, amountCo2Field, 'number')) values.errors.push({ key: 'amountCo2Field', label: 'AmountNanError' })
  if (!use_company_name_in_offset) {
    if (isNotTypeOnArray(excelData, nameField, 'string')) values.errors.push({ key: 'nameField', label: 'NameStrError' })
    if (isNotTypeOnArray(excelData, lastNameField, 'string')) values.errors.push({ key: 'lastNameField', label: 'LastNameStrError' })
  } else {
    if (isNotTypeOnArray(excelData, companyNameField, 'string')) values.errors.push({ key: 'companyNameField', label: 'companyNameFieldError' })
  }
  if (isNotTypeOnArray(excelData, emailField, 'email')) values.errors.push({ key: 'emailField', label: 'EmailError' })
  values.hasErrors = values.errors.length > 0
  return values
}

// Manage Offset By Excel request to backend data
export const getOffsetByExcelRequestData = (state: AppState,) => {
  const { integration_code } = state.myIntegration.integrationStatics.data
  // Get Date From Offset By Excel State
  const {
    offsetKeys, preparePurchases, excelData,
    offsetOptionalKeys, optionalFields: { use_company_name_in_offset }
  } = state.myIntegration.offsetByExcel

  // Destructure offset excel keys
  const {
    nameField, lastNameField, emailField, amountCo2Field,
    identifierField, co2UnitField, companyNameField
  } = offsetKeys
  const { selectedProjectId , data: filteredOffsets,selectedVintageYear: year } = preparePurchases
  const co2Multiplier = { KG: 0.001, TONS: 1 }[co2UnitField]

  // Filter excel data from filtered offset
  const offsets = excelData.filter(x => filteredOffsets?.some(y => x[identifierField] === y[identifierField]))
  // Build Request
  return offsets.map((x: any) => {
    // Optional Extra data
    const optionalData = getOptionalFieldWithExcelData(offsetOptionalKeys, x)
    const optionalExtraData = optionalData?.reduce((a, v) => ({ ...a, [v.field]: v.value }), {})
    // Ticket Data
    const ticketData = {
      NAME: { first_name: x[nameField], last_name: x[lastNameField] },
      // Its required on backend, cant be deleted cause other features need it
      COMPANY: { company_name: x[companyNameField], first_name: 'Non-Empty', last_name: 'Non-Empty', use_company_name: true }
    }[use_company_name_in_offset ? 'COMPANY': 'NAME']
    const { total_amount: price } = selectFinalUnitPrice(state)
    const amount = x[amountCo2Field]
    const emissionsFromCurrency = price && amount ? (+amount / price):0
    const co2_amount =  +(co2Multiplier ? amount * co2Multiplier : emissionsFromCurrency)?.toFixed(3)
    const payload ={
      offsets: [
        {
          integration_code,
          project: selectedProjectId,
          co2_amount,
          extra_data: {
            ...x,
            ...optionalExtraData,
            transaction_identifier: x[identifierField]
          }
        }
      ],
      ticket_data: {
        ...ticketData,
        email: x[emailField]
      }
    }
    if (year) { payload['offsets'][0]['year'] = year }
    return payload
  })
}
